var _circle, _circle2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMegaphonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 10,
    fill: "#F2C769"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#F2C769",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.667 9.625h-.334c-.184 0-.333.14-.333.313v.252L8.985 12.367a.325.325 0 00-.318-.242h-.334c-.184 0-.333.14-.333.313v3.124c0 .173.15.313.333.313h.334a.325.325 0 00.318-.242l2.396.52a1.634 1.634 0 00-.047.347c0 1.035.895 1.875 2 1.875.92 0 1.687-.586 1.918-1.38L19 17.81v.253c0 .172.15.312.333.312h.334c.184 0 .333-.14.333-.313V9.938c0-.172-.15-.312-.333-.312zm-6.334 7.813c-.551 0-1-.421-1-.938 0-.047.02-.089.026-.134l1.922.418a.993.993 0 01-.948.654zM9 14.674v-1.348l10-2.174v5.696L9 14.674z",
    fill: "#856727"
  })));
}

export default __webpack_public_path__ + "./fonts/megaphon_icon.aa7785e98b1f37105870752dbaec43e8.svg";
export { SvgMegaphonIcon as ReactComponent };